
import React, { CSSProperties } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';
import { IconFontProps } from '@ant-design/icons/lib/components/IconFont';

export type ColorType = 'default' | 'primary';
type IProps = {
  type: string
  color?: string
  size?: number | string
  onClick?: () => void
  hover?: boolean
  disabled?: boolean
  rotate?: boolean
  colorType?: ColorType,
  style?: CSSProperties
}
const IconWrapper = (Component: React.FC<IconFontProps>) => ({
  onClick,
  size,
  color = '#8f959e',
  type,
  hover = false,
  disabled = false,
  rotate = false,
  style
}: IProps) => {
  const IconFontCls = classnames(styles.icon, {
    [styles.hover]: !disabled && hover,
    [styles.disabled]: disabled,
    [styles.rotate]: rotate
  });
  return (
    <Component
      className={IconFontCls}
      type={type}
      style={{ ...style, fontSize: size + 'px', color: color }}
      onClick={() => { if (!disabled && typeof onClick === 'function') { onClick(); } }}
    />
  );
};
export default IconWrapper;
